module.exports = __webpack_public_path__ + "static/media/logo2.7b0117dc.png";